import * as React from 'react';
import { translate } from 'react-i18next';
import { TooltipWrapper, TooltipTitle, TooltipItemList, TooltipItem } from 'common/components/charts/tooltip/RechartsToolTipStyles';

interface Props {
  payload?: Object[];
  t: any;
  valueFormatter: (value: any) => any;
}

export function PieChartTooltip({ payload, t, valueFormatter }: Props) {
  if (!payload || payload.length === 0) {
    return null;
  }

  const payloadValue = payload[0].value;
  const value = valueFormatter ? valueFormatter(payloadValue) : payloadValue;

  return (
    <TooltipWrapper>
      <TooltipTitle>{payload[0].name}</TooltipTitle>
      <TooltipItemList>
        <TooltipItem color={payload[0].payload.fill}>{t('percentage')} : {value}</TooltipItem>
      </TooltipItemList>
    </TooltipWrapper>
  );
}

export default translate()(PieChartTooltip);



// WEBPACK FOOTER //
// ./src/common/components/ui/charts/wrappers/PieChartTooltip.js